import Auth from '@aws-amplify/auth';

const PACKAGE_WARNINGS_TO_SUPPRESS = [
  {
    package: '@amzn/meridian',
    messageIncludes: 'Support for defaultProps will be removed',
  },
];

/**
 * This to run before react loads
 */
export function Init(): void {
  // The meridian error about `defaultProps` was flooding my browser's console
  // output so I was missing other errors
  // eslint-disable-next-line no-process-env
  if (process.env.NODE_ENV === 'development') {
    const originalError = console.error;
    console.error = (...args) => {
      for (const warning of PACKAGE_WARNINGS_TO_SUPPRESS) {
        if (
          typeof args[0] === 'string' &&
          args[0].includes(warning.messageIncludes) &&
          typeof args[2] === 'string' &&
          args[2].includes(`node_modules/${warning.package}/`)
        ) {
          return;
        }
      }
      originalError(...args);
    };
  }
  // Setup Authentication
  Auth.configure({
    stage: 'gamma',
    aws_cognito_region: 'us-east-1',
    aws_cognito_identity_pool_id: 'us-east-1:778228ec-544b-4366-92a7-7d3b556b672d',
    aws_user_pools_id: 'us-east-1_2cWyXhQ8j',
    aws_user_pools_web_client_id: '52ereuthsf96qmd37mo93kc4r0',
    Auth: {
      identityPoolId: 'us-east-1:778228ec-544b-4366-92a7-7d3b556b672d',
      region: 'us-east-1',
      userPoolId: 'us-east-1_2cWyXhQ8j',
      userPoolWebClientId: '52ereuthsf96qmd37mo93kc4r0',
    },
    oauth: {
      domain: `rtw-tool-gamma-na.auth.us-east-1.amazoncognito.com`,
      redirectSignIn: 'https://gamma.na.rtw.whs.amazon.dev',
      redirectSignOut: 'https://gamma.na.rtw.whs.amazon.dev',
      scope: ['openid', 'profile'],
      responseType: 'code',
    },
  });
}
